// extracted by mini-css-extract-plugin
module.exports = {"button":"ContentCarousel__button","buttonPrev":"ContentCarousel__buttonPrev","buttonNext":"ContentCarousel__buttonNext","wrapper":"ContentCarousel__wrapper"};